import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  DxGanttComponent,
  DxGanttModule,
  DxSelectBoxModule,
  DxCheckBoxComponent,
  DxPopoverComponent,
} from 'devextreme-angular';
import {
  ConfigScheduleItem,
  GanttDependancy,
  GanttDependencyType,
  GanttTask,
  RelativeGanttTask,
} from './config-schedule.types';
import { map } from 'jquery';
import { relative } from 'path';
import { forEach } from 'jszip';
import { start } from 'repl';
import {
  ContentReadyEvent,
  ContextMenuPreparingEvent,
  DependencyDeletedEvent,
  DependencyInsertedEvent,
  DependencyInsertingEvent,
  ScaleCellPreparedEvent,
  TaskMovingEvent,
  TaskUpdatedEvent,
  TaskUpdatingEvent,
} from 'devextreme/ui/gantt';
import { ValueChangedEvent } from 'devextreme/ui/switch';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { Subscription } from 'rxjs';
import { TemplatesService } from 'src/app/services/templates.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ScheduleService } from 'src/app/services/schedule-item.service';
import { AppGlobals } from 'src/app/app.globals';
import { DxoFormComponent } from 'devextreme-angular/ui/nested';
import { SvgIconComponent } from 'src/app/components/svg-icon/svg-icon.component';
import { GenericPopupComponent } from 'src/app/components/generic-popup/generic-popup.component';

import { SearchableDropdownDirective } from '../../../../directives/searchable-dropdown.directive';
@Component({
    selector: 'app-config-schedule',
    imports: [
        DxGanttModule,
        DxSelectBoxModule,
        CommonModule,
        GpdButtonComponent,
        DxCheckBoxComponent,
        DxPopoverComponent,
        SvgIconComponent,
        GenericPopupComponent,
        SearchableDropdownDirective,
    ],
    templateUrl: './config-schedule.component.html',
    styleUrls: ['./config-schedule.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfigScheduleComponent implements OnInit, OnDestroy {
  areaTypes: any[] = [];
  scheduleItems: ConfigScheduleItem[] = [];
  ganttTasks: GanttTask[] = [];
  ganttDependancies: GanttDependancy[] = [];
  firstMonday: Date = new Date('01-01-2023'); //stats on a Sunday
  typeColors = {
    Package: '#629D37',
    Milestone: '#00A4EF',
    Phase: '#8B5CF6',
  };

  areaTypeId: number;
  requireUpdate: boolean = false;
  loading: boolean = false;

  safeMode: boolean = true;
  showDisableDeps: boolean = false;
  showCircularDepError: boolean = false;
  dontshowAgain: boolean = false;
  isAdmin: boolean = AppGlobals.UserPermissions.isAdministrator;

  subscribtions: Subscription[] = [];

  @ViewChild('gantt') gantt: DxGanttComponent;

  constructor(
    private cdr: ChangeDetectorRef,
    private templatesService: TemplatesService,
    private scheduleService: ScheduleService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.dontshowAgain = localStorage.getItem('dependancyDisableWarning') === 'true';
    this.subscribtions.push(
      this.route.queryParams.subscribe(params => {
        this.areaTypeId = +params.areaTypeId ? +params.areaTypeId : null;
        if (this.areaTypeId != null) {
          this.getSchedule().then(() => this.gantt.instance.scrollToDate(this.firstMonday));
        }
      })
    );

    this.subscribtions.push(
      this.templatesService.areaTypes$.subscribe(areaTypes => {
        this.areaTypes = areaTypes;
        if (this.areaTypeId == null) {
          this.areaTypeId = this.areaTypes.at(0)?.id;
          this.router.navigate(['project-schedule'], {
            relativeTo: this.route.parent,
            queryParams: {
              areaTypeId: this.areaTypeId,
            },
          });
        }
        this.cdr.markForCheck();
      })
    );

    this.templatesService.loadAreaTypes();
  }

  onContextMenuPreparing(e: ContextMenuPreparingEvent) {
    if (e.targetType === 'task') {
      e.cancel = true;
    }
  }

  ngOnInit() {
    if (this.areaTypeId == null && this.areaTypes.length > 0) {
      this.areaTypeId = this.areaTypes[0].id;
      this.getSchedule().then(() => this.gantt.instance.scrollToDate(this.firstMonday));
    }
  }

  ngOnDestroy(): void {
    this.subscribtions.forEach(s => s.unsubscribe());
  }

  onScaleCellPrepared(e: ScaleCellPreparedEvent) {
    var scaleElement = e.scaleElement;
    if(e.startDate.getTime() < this.firstMonday.getTime()){
      scaleElement.innerText = '';
      return;
    }
    if (e.scaleType === 'days') {
      const dayNumber = e.startDate.getDay() + 1;
      scaleElement.innerText = dayNumber > 0 ? dayNumber.toString() : '';
    } else if (e.scaleType === 'weeks') {
      const weekNum = this.getRelativeWeekNumber(e.startDate) + 1;
      scaleElement.innerText = weekNum > 0 ? $localize`:@@week:Week` + ` ${weekNum}` : '';
    } else if (e.scaleType === 'months') {
      const monthNum = this.getRelativeMonthNumber(e.startDate);
      scaleElement.innerText = monthNum > 0 ? $localize`:@@month:Month` + ` ${monthNum}` : '';
    } else if (e.scaleType === 'years') {
      const yearNum = e.startDate.getFullYear() - this.firstMonday.getFullYear() + 1;
      scaleElement.innerText = yearNum > 0 ? $localize`:@@year:Year` + ` ${yearNum}` : '';
    }
  }

  getDayNumber(date: Date): number {
    const startOfWeek = this.firstMonday;
    const targetWeekStart = date;

    const diffTime = targetWeekStart.getTime() - startOfWeek.getTime();
    const diffWeeks = Math.floor(diffTime / (24 * 60 * 60 * 1000));

    return diffWeeks + 1;
  }

  getRelativeWeekNumber(date: Date): number {
    const startOfWeek = this.firstMonday;
    const targetWeekStart = this.getMonday(date);

    const diffTime = targetWeekStart.getTime() - startOfWeek.getTime();
    const diffWeeks = Math.floor(diffTime / (7 * 24 * 60 * 60 * 1000));

    return diffWeeks + 1;
  }

  private getMonday(date: Date): Date {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    const newdate = new Date(d.setDate(diff));
    return new Date(newdate.setHours(0, 0, 0, 0));
  }

  private getRelativeMonthNumber(date: Date): number {
    const startMonth = this.firstMonday.getFullYear() * 12 + this.firstMonday.getMonth();
    const targetMonth = date.getFullYear() * 12 + date.getMonth();

    return targetMonth - startMonth + 1;
  }

  async getSchedule() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    try {
      const result = await this.scheduleService.getScheduleItemConfig(this.areaTypeId);
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
      } else {
        this.scheduleItems = result.scheduleItems;
        this.mapGanttTasks();
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
    this.loading = false;
  }

  async writeScheduleItem(item: ConfigScheduleItem) {
    try {
      const result = await this.scheduleService.updateScheduleItem({ scheduleItem: item, areaTypeId: this.areaTypeId });
      if (result.hasError) {
        AppGlobals.ShowErrorMessage(result.feedback);
      }
    } catch (error) {
      AppGlobals.ShowErrorMessage(error);
    }
  }

  mapGanttTasks() {
    this.ganttTasks = [];
    this.ganttDependancies = [];
    let relitiveTasks: Map<number, RelativeGanttTask> = new Map();
    // Ids currently on the recursion stack. Mirrors the backend's CalculateRelitiveScheduleRec
    // visitedIds guard: without it, a circular reference in the schedule config (parent-child or
    // dependency) recurses forever and throws "Maximum call stack size exceeded".
    const visiting = new Set<number>();

    const mapGanttTaskRecursive = (id: number | null): { start: number; end: number } => {
      if (id != null) {
        if (relitiveTasks.has(id)) {
          const cached = relitiveTasks.get(id);
          return { start: cached.startDate, end: cached.endDate };
        }
        if (visiting.has(id)) {
          // Circular reference detected - break the recursion instead of overflowing the stack.
          this.showCircularDepError = true;
          return { start: 0, end: 0 };
        }
        visiting.add(id);
      }

      const item = this.scheduleItems.find(item => item.id === id);
      const children = this.scheduleItems.filter(s => s.parentId === id);
      let start = item?.startOffset ?? 0;
      let end = item?.startOffset ?? 0;

      if (children.length > 0) {
        for (const child of children) {
          let childStart;
          let childEnd;
          if (!relitiveTasks.has(child.id)) {
            const res = mapGanttTaskRecursive(child.id);
            childStart = res.start;
            childEnd = res.end;
          } else {
            const c = relitiveTasks.get(child.id);
            childStart = c.startDate;
            childEnd = c.endDate;
          }

          if (childStart < start) {
            start = childStart;
          }
          if (childEnd > end) {
            end = childEnd;
          }
        }
      } else if (item != null) {
        if (item?.dependencyOnId !== null && item?.dependencyOnId !== undefined) {
          this.ganttDependancies.push({
            id: this.ganttDependancies.length,
            dependancyOnId: item.dependencyOnId,
            dependencyType: item.dependencyType,
            taskId: item.id,
          });
          if (!relitiveTasks.has(item.dependencyOnId)) {
            mapGanttTaskRecursive(item.dependencyOnId);
          }
          const dependancy = relitiveTasks.get(item.dependencyOnId);

          // dependancy is undefined when the dependency target is missing or was skipped as a
          // circular-reference edge above; fall back to the item's own offsets in that case.
          if (dependancy) {
            switch (item.dependencyType) {
              case GanttDependencyType.FF:
              case GanttDependencyType.FS:
                start += dependancy.endDate;
                end += dependancy.endDate;
                break;
              case GanttDependencyType.SS:
              case GanttDependencyType.SF:
                start += dependancy.startDate;
                end += dependancy.startDate;
                break;
            }
          }
          switch (item.dependencyType) {
            case GanttDependencyType.SS:
            case GanttDependencyType.FS:
              end += item.duration ?? 0;
              break;
            case GanttDependencyType.SF:
            case GanttDependencyType.FF:
              start -= item.duration ?? 0;
              break;
          }
        } else {
          end += item.duration;
        }
      }
      if (item) {
        relitiveTasks.set(id, {
          id: item.id,
          parentId: item.parentId,
          startDate: start,
          endDate: end,
        });
      }
      if (id != null) {
        visiting.delete(id);
      }
      return { start, end };
    };

    mapGanttTaskRecursive(null);
    let sItems = this.scheduleItems.filter(
      si => si.itemType == 'Package' || this.scheduleItems.some(s => s.parentId == si.id)
    );

    this.ganttTasks = sItems.map(item => {
      const relativeTask = relitiveTasks.get(item.id);
      // add the start date to the current date
      return {
        id: item.id,
        parentId: item.parentId,
        title: item.title,
        startDate: new Date(
          this.firstMonday.getFullYear(),
          this.firstMonday.getMonth(),
          this.firstMonday.getDate() + relativeTask.startDate,
          0,
          0,
          0,
          0
        ),
        endDate: new Date(
          this.firstMonday.getFullYear(),
          this.firstMonday.getMonth(),
          this.firstMonday.getDate() + relativeTask.endDate,
          0,
          0,
          0,
          0
        ),
        color: this.typeColors[item.itemType],
        sortingIndex: item.sortingIndex,
      };
    });
    ((this.startGantt = new Date(
      this.firstMonday.getFullYear(),
      this.firstMonday.getMonth(),
      this.firstMonday.getDate() - 5,
      0,
      0,
      0,
      0
    )),
      this.cdr.markForCheck());
  }

  startGantt: Date;

  onTaskMoving(e: TaskMovingEvent) {
    if (e.newValues.startDate && e.newValues.startDate?.getTime() < this.firstMonday.getTime()) {
      const dur = e.newValues.endDate.getTime() - e.newValues.startDate.getTime();
      e.newValues.startDate = this.firstMonday;
      e.newValues.endDate = new Date(e.newValues.startDate.getTime() + dur);
    }
  }

  onAreaTypeChanged(e: any) {
    this.areaTypeId = e.value;
    this.router.navigate(['project-schedule'], {
      relativeTo: this.route.parent,
      queryParams: {
        areaTypeId: this.areaTypeId,
      },
    });
  }

  onTaskUpdating(e: TaskUpdatingEvent) {
    let newStart = e.newValues.startDate ?? e.values.startDate;
    let newEnd = e.newValues.endDate ?? e.values.endDate;
    //round
    newStart = new Date(Math.round(newStart.getTime() / 1000 / 60 / 60 / 24) * 1000 * 60 * 60 * 24);
    newEnd = new Date(Math.round(newEnd.getTime() / 1000 / 60 / 60 / 24) * 1000 * 60 * 60 * 24);

    if (e.newValues.startDate) {
      const dur = (newEnd.getTime() - newStart.getTime()) / 1000 / 60 / 60 / 24;
      if (dur < 1) {
        //start date = end date - 1 day
        e.newValues.startDate = new Date(newEnd.getTime() - 24 * 60 * 60 * 1000);
      }
    }
    if (e.newValues.endDate) {
      const dur = (newEnd.getTime() - newStart.getTime()) / 1000 / 60 / 60 / 24;
      if (dur < 1) {
        //end date = start date + 1 day
        e.newValues.endDate = new Date(newStart.getTime() + 24 * 60 * 60 * 1000);
      }
    }
  }

  async onTaskUpdated(e: TaskUpdatedEvent) {
    // TODO: here values doesnt contain this field
    if (e.values?.completionDate) {
      return;
    }
    if (this.ganttTasks.some(s => s.startDate.getTime() < this.firstMonday.getTime())) {
      this.getSchedule();
      return;
    }

    const item = this.scheduleItems.find(s => s.id === e.key);
    const ganttItem = this.ganttTasks.find(s => s.id === e.key);

    let start = e.values.startDate ?? ganttItem.startDate;
    let end = e.values.endDate ?? ganttItem.endDate;
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    if (item && item.itemType == 'Package') {
      let newOffset: number = null;
      let newDuration: number = null;

      const ganttDep = this.ganttDependancies.find(s => s.taskId === e.key);
      if (ganttDep) {
        const dependancy = this.ganttTasks.find(s => s.id === ganttDep.dependancyOnId);
        dependancy.startDate.setHours(0, 0, 0, 0);
        dependancy.endDate.setHours(0, 0, 0, 0);
        let diff: number;
        // Choose relative date based on dependency type
        switch (ganttDep.dependencyType) {
          case GanttDependencyType.FF: {
            diff = end.getTime() - dependancy.endDate.getTime();
            break;
          }
          case GanttDependencyType.FS: {
            diff = start.getTime() - dependancy.endDate.getTime();
            break;
          }
          case GanttDependencyType.SS: {
            diff = start.getTime() - dependancy.startDate.getTime();
            break;
          }
          case GanttDependencyType.SF: {
            diff = end.getTime() - dependancy.startDate.getTime();
            break;
          }
        }
        if (diff < 0) {
          diff = 0;
        }

        newOffset = diff / 1000 / 60 / 60 / 24;
      } else {
        this.firstMonday.setHours(0, 0, 0, 0);
        let diff = start.getTime() - this.firstMonday.getTime();
        newOffset = diff / 1000 / 60 / 60 / 24;
      }

      let diff = end.getTime() - start.getTime();
      newDuration = diff / 1000 / 60 / 60 / 24;

      if (
        (newOffset != item.startOffset && newOffset != null) ||
        (newDuration != item.duration && newDuration != null)
      ) {
        item.startOffset = Math.round(newOffset ?? item.startOffset);
        item.duration = Math.round(newDuration);
        await this.writeScheduleItem(item);
        this.requireUpdate = true;
      }
    }
    if (ganttItem) {
      await this.calculateDependants(ganttItem);
    }

    if (this.requireUpdate) {
      this.requireUpdate = false;
      this.getSchedule();
    }
  }

  private async calculateDependants(task: GanttTask) {
    const ganttDeps = this.ganttDependancies.filter(s => s.dependancyOnId === task.id);
    for (const dep of ganttDeps) {
      let newOffset: number = null;
      const dependancy = this.ganttTasks.find(s => s.id === dep.taskId);
      const depScheduleItem = this.scheduleItems.find(s => s.id === dep.taskId);
      let relativeDate = new Date(this.firstMonday);
      switch (dep.dependencyType) {
        case GanttDependencyType.FF:
        case GanttDependencyType.FS:
          relativeDate = new Date(task.endDate);
          break;
        case GanttDependencyType.SS:
        case GanttDependencyType.SF:
          relativeDate = new Date(task.startDate);
          break;
      }
      relativeDate.setHours(0, 0, 0, 0);
      let diff: number;
      switch (dep.dependencyType) {
        case GanttDependencyType.SS:
        case GanttDependencyType.FS:
          diff = dependancy.startDate.getTime() - relativeDate.getTime();
          break;
        case GanttDependencyType.SF:
        case GanttDependencyType.FF:
          diff = dependancy.endDate.getTime() - relativeDate.getTime();
          break;
      }
      newOffset = diff / 1000 / 60 / 60 / 24;
      if (
        newOffset != depScheduleItem.startOffset &&
        depScheduleItem.startOffset != 0 &&
        depScheduleItem.startOffset != null
      ) {
        depScheduleItem.startOffset = newOffset ?? depScheduleItem.startOffset;
        await this.writeScheduleItem(depScheduleItem);
        this.requireUpdate = true;
      }
    }
  }

  onDependencyInserting(e: DependencyInsertingEvent) {
    const succ = this.scheduleItems.find(s => s.id == e.values.taskId);
    const pred = this.scheduleItems.find(s => s.id == e.values.dependancyOnId);

    if (!succ || !pred) {
      e.cancel = true;
      return;
    }
    if (succ.itemType != 'Package') {
      e.cancel = true;
      return;
    }
    if (succ.dependencyOnId) {
      e.cancel = true;
      return;
    }

    // Check for circular dependency
    if (this.wouldCreateCircularDependency(e.values.taskId, e.values.dependancyOnId)) {
      this.showCircularDepError = true;
      this.cdr.markForCheck();
      e.cancel = true;
    }
  }

  private wouldCreateCircularDependency(successorId: number, predecessorId: number): boolean {
    const visited = new Set<number>();
    const queue: number[] = [predecessorId];

    // Also add all children of the predecessor (recursively) since parent dates are determined by children
    const addChildrenToQueue = (parentId: number) => {
      const children = this.scheduleItems.filter(s => s.parentId == parentId);
      for (const child of children) {
        if (!visited.has(child.id)) {
          queue.push(child.id);
          addChildrenToQueue(child.id);
        }
      }
    };
    addChildrenToQueue(predecessorId);
    while (queue.length > 0) {
      const currentId = queue.shift();
      if (currentId == successorId) {
        return true;
      }

      if (visited.has(currentId)) {
        continue;
      }
      visited.add(currentId);

      // Check if current task has a dependency
      const currentTask = this.ganttDependancies.find(s => s.taskId == currentId);
      if (currentTask?.dependancyOnId) {
        queue.push(currentTask.dependancyOnId);
        // Also add children of the dependency target
        addChildrenToQueue(currentTask.dependancyOnId);
      }
    }

    return false;
  }

  onDependencyInserted(e: DependencyInsertedEvent) {
    let task = this.scheduleItems.find(s => s.id === e.values.taskId);
    const ganttTask = this.ganttTasks.find(s => s.id === e.values.taskId);
    task.dependencyOnId = e.values.dependancyOnId;
    task.dependencyType = e.values.dependencyType;
    this.onTaskUpdated({
      ...e,
      key: ganttTask.id,
      values: { startDate: ganttTask.startDate, endDate: ganttTask.endDate },
    });
  }

  onDependencyDeleted(e: DependencyDeletedEvent) {
    let task = this.scheduleItems.find(s => s.id === e.values.taskId);
    const ganttTask = this.ganttTasks.find(s => s.id === e.values.taskId);
    task.dependencyOnId = null;
    task.dependencyType = null;
    this.onTaskUpdated({
      ...e,
      key: ganttTask.id,
      values: { startDate: ganttTask.startDate, endDate: ganttTask.endDate },
    });
  }

  getDuration(startDate: Date, endDate: Date) {
    const diff = endDate.getTime() - startDate.getTime();
    const diffDays = Math.floor(diff / (24 * 60 * 60 * 1000));
    return diffDays;
  }

  onSafeModeChanged(e: ValueChangedEvent) {
    if (e.value === false && e.previousValue === true && !this.dontshowAgain) {
      this.showDisableDeps = true;
    }
    this.gantt?.instance.repaint();
  }

  onDontShowAgainChanged(e: ValueChangedEvent) {
    if (e.value === true) {
      this.dontshowAgain = true;
      localStorage.setItem('dependancyDisableWarning', 'true');
    } else {
      this.dontshowAgain = false;
      localStorage.removeItem('dependancyDisableWarning');
    }
  }
}
